import { FetchServiceOptions } from '../types/service-configs';
import { ServiceConfigProviderSetup } from '@volkswagen-onehub/service-config-provider';

function createFetchUrl(
  serviceURl: string | undefined,
  endpoint: string,
): string {
  serviceURl = !serviceURl?.endsWith('/')
    ? serviceURl?.concat('/')
    : serviceURl;

  const query = new URLSearchParams();

  return `${serviceURl || ''}${endpoint}?${query}`;
}

export async function fetchServiceConfigs({
  serviceURl,
  endpoint,
}: FetchServiceOptions): Promise<ServiceConfigProviderSetup> {
  const url = createFetchUrl(serviceURl, endpoint);
  const response = await fetch(url);
  const configs = await response.json();

  if (response.status >= 500) {
    return { configs: {} };
  }
  return configs;
}
